import React, { Component } from 'react';

import { SCREEN_ID_REFER_RENTER } from 'client/constants/screenIds';
import { URL_IABS } from 'client/constants/urls';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import SrLink from 'client/components/SrLink/SrLink';

@withTransitionHook
@withScreenId(SCREEN_ID_REFER_RENTER)
@withScrollToTop
class ReferRenter extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Refer a Renter to Sunroom | Get $20',
    section: 'Refer Renter',
    keywords: 'rent, home, austin, tour, apartment',
    description: (
      'You get tons of extra renter leads from Zillow ' +
      'and other sites, forward them to us and ' +
      'get paid $20 if they sign a lease anywhere!'
    ),
    image: 'https://sunroomrentals.com/images/metadata/og-house.jpg',
  })

  render() {
    return (
      <div className='page-landing page-refer-renter'>
        <div id='navbar' className='clearfix'>
          <SrLink to='/' className='logo' />
          <SrLink to='/login' id='login'>Log In</SrLink>
        </div>

        <div className='hero'>
          <div className='column-left'>
            <h1>Refer your “junk” renter leads</h1>
            <h2>
              You get tons of extra renter leads from
              <br />
              Zillow&nbsp;and other sites, forward them to us and
              <br />
              <span className='green'>get paid $20</span> if they sign a lease anywhere!
            </h2>
            <SrLink
              to='https://sunroom.typeform.com/to/gUn94S'
              className='button yellow cta'
            >
              refer renter lead
            </SrLink>
          </div>
          <div className='column-right'>
            <span className='hero-image' />
          </div>
        </div>

        <div className='section tagline'>
          <span className='one-liner'>
            <div>Forward the emails from your bad renter leads to Sunroom.</div>
            <div>
              <span className='green'>Get paid $20</span> if they sign a lease anywhere!
            </div>
          </span>
        </div>

        <div className='section news'>
          <span className='headline'>
            Sunroom just raised <span className='bold'>$1.5M</span>, see us in the news:
          </span>
          <div className='logosContainer'>
            <span className='newsLogo statesman' />
            <span className='newsLogo abor' />
            <span className='newsLogo realtor' />
            <span className='newsLogo kvue' />
            <span className='newsLogo austininno' />
          </div>
        </div>

        <div className='section how-it-works clearfix'>
          <span className='header'>How it works</span>
          <div className='bullet-point'>
            <span className='number'>1</span>
            <span className='title'>Check your email for leads</span>
            <span className='description'>
              You get tons of leads for rentals you have listed on other sites.
            </span>
          </div>
          <div className='bullet-point'>
            <span className='number'>2</span>
            <span className='title'>Forward leads to Sunroom</span>
            <span className='description'>
              Figure out which leads you don’t want, and simply
              <br />
              forward them to Sunroom at
              <br />
              <span className='bold'>refer@sunroomrentals.com</span>
            </span>
          </div>
          <div className='bullet-point'>
            <span className='number'>3</span>
            <span className='title'>
              <span className='green'>Get paid $20</span> if
              <br />
              they sign a lease
            </span>
            <span className='description'>
              If your referal signs a lease anywhere with Sunroom, we’ll pay you $20!
            </span>
          </div>
        </div>

        <div className='section tenants'>
          <span className='header'>Why agents <span className='italics'>trust</span> Sunroom</span>

          <div className='column-left'>
            <span id='tenants-photo' />
          </div>

          <div className='column-right'>
            <div className='bullet-point'>
              <img src='/images/checkmark.svg' alt='' className='checkmark' />
              <span className='title'>We <span className='bold italics'>never</span> sell homes</span>
              <span className='description'>
                You keep your relationship with the landlord. We’ll focus on getting the renter closed.
              </span>
            </div>
            <div className='bullet-point'>
              <img src='/images/checkmark.svg' alt='' className='checkmark' />
              <span className='title'>We represent you well</span>
              <span className='description'>
                Our vetted, licensed tour agents serve renters with a smile. We have a dedicated support team.
              </span>
            </div>
            <div className='bullet-point'>
              <img src='/images/checkmark.svg' alt='' className='checkmark' />
              <span className='title'>You're in control</span>
              <span className='description'>
                Easily track, review, and contact your renter leads online!
                You have total oversight of your leads.
              </span>
            </div>
          </div>
        </div>

        <div className='section recap'>
          <span className='header'>Refer your “junk” renter leads</span>
          <span className='subheader'>
            <span className='green'>Get paid $20</span> if they sign a lease anywhere!
          </span>
          <SrLink
            to='https://sunroom.typeform.com/to/gUn94S'
            className='button yellow cta'
          >
            refer renter lead
          </SrLink>
        </div>

        <div className='footer'>
          <span>Made with ❤ in Austin, TX.</span>
          <br />
          <span>
            Want to work with us? Apply on our
            <SrLink to='https://sunroom.recruitee.com/' target='_blank'> careers page</SrLink>
            .
          </span>
          <br />
          <br />
          <br />
          <div>
            <span>
              <SrLink
                to={URL_IABS}
                target='_blank'
              >
                IABS
              </SrLink>
              &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
              <SrLink
                to='https://www.trec.texas.gov/forms/consumer-protection-notice'
                target='_blank'
              >
                TREC Consumer Protection
              </SrLink>
            </span>
          </div>
          <div>
            <span>TREC #9007204&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;help@sunroomrentals.com</span>
          </div>
          <span className='attribution'>
            Based on information from the Austin Board of REALTORS® for the period through
            today. All listing information is deemed reliable but is not guaranteed and should
            be independently verified. The Austin Board of REALTORS®, ACTRIS and their
            affiliates provide the MLS and all content therein “AS IS” and without any warranty,
            express or implied. Listing information is provided exclusively for consumers’ personal,
            non-commercial use and may not be used for any purpose other than to identify prospective
            properties consumers may be interested in purchasing.
          </span>
        </div>
      </div>
    );
  }
}

ReferRenter.displayName = 'ReferRenter';

export default ReferRenter;
